<template>

  <ul v-if="login.loggedIn" class="sidebar-menu tree" data-widget="tree">

    <li class="treeview menu-open" :class="'pageLink '+(active == '/realtime' || active == '/map'?'active':'')">

      <a class="no-events" href="#">
        <i class="fa fa-caret-right"></i> <span>Cartes</span>
      </a>
      <ul class="treeview-menu" style="display: block;">
        <li v-if="login.loggedIn &&  currentVille.moduleBackoffice.find(m =>m.parametrageBOMenu === 'TEMPS_REEL').actif" :class="'pageLink '+(active == '/realtime'?'active':'')">
          <router-link to="/realtime" v-on:click="closeMenu()">
            <i class="fa fa-caret-right"></i>
            Temps réel
          </router-link>
        </li>
        <li v-if="login.loggedIn && currentVille.moduleBackoffice.find(m =>m.parametrageBOMenu === 'PARCOURS').actif" :class="'pageLink '+(active == '/map'?'active':'')">
          <router-link to="/map">
            <i class="fa fa-caret-right"></i>
            Parcours
          </router-link>
        </li>
        <li v-if="login.loggedIn && currentVille.moduleBackoffice.find(m =>m.parametrageBOMenu === 'REPORTING').actif" :class="'pageLink '+(active == '/reporting'?'active':'')">
          <router-link to="/reporting">
            <i class="fa fa-caret-right"></i>
            Reporting
          </router-link>
        </li>
         <li v-if="login.loggedIn && currentVille.moduleBackoffice.find(m =>m.parametrageBOMenu === 'IMPLANTATION_DES_CONTENANTS').actif" :class="'pageLink '+(active == '/implantation_des_contenants'?'active':'')">
          <router-link to="/implantation_des_contenants">
            <i class="fa fa-caret-right"></i>
            implantation <br> &nbsp;&nbsp;&nbsp; contenants
          </router-link>
        </li>
      </ul>
    </li>

    <li v-if="login.loggedIn && store.state.currentUser.role !== 'COLLECTIVITY_USER'  && currentVille.moduleBackoffice.find(m =>m.parametrageBOMenu === 'TOURNEES').actif" :class="'pageLink '+(active == '/tournees'?'active':'')">
      <router-link to="/tournees"><i class="fa fa-caret-right"></i>
        <span class="page">Tournées</span>
      </router-link>
    </li>

    <li v-if="login.loggedIn && store.state.currentUser.role !== 'COLLECTIVITY_USER'  && currentVille.moduleBackoffice.find(m =>m.parametrageBOMenu === 'MATERIELS').actif" :class="'pageLink '+(active == '/materiels'?'active':'')">
      <router-link to="/materiels"><i class="fa fa-caret-right"></i>
        <span class="page">Matériels</span>
      </router-link>
    </li>

    <li v-if="login.loggedIn && store.state.currentUser.role !== 'COLLECTIVITY_USER'  && currentVille.moduleBackoffice.find(m =>m.parametrageBOMenu === 'MAITRISES').actif" :class="'pageLink '+(active == '/maitrises'?'active':'')">
      <router-link to="/maitrises"><i class="fa fa-caret-right"></i>
        <span class="page">Maîtrises</span>
      </router-link>
    </li>

    <li v-if="login.loggedIn && store.state.currentUser.role !== 'COLLECTIVITY_USER'  && currentVille.moduleBackoffice.find(m =>m.parametrageBOMenu === 'CANTONNIERS').actif" :class="'pageLink '+(active == '/cantonniers'?'active':'')">
      <router-link to="/cantonniers">
        <i class="fa fa-caret-right"></i>
        <span class="page">Cantonniers</span>
      </router-link>
    </li>

    <li v-if="login.loggedIn && store.state.currentUser.role !== 'COLLECTIVITY_USER'  && currentVille.moduleBackoffice.find(m =>m.parametrageBOMenu === 'SECTEURS').actif" :class="'pageLink '+(active == '/secteurs'?'active':'')">
      <router-link to="/secteurs">
        <i class="fa fa-caret-right"></i>
        <span class="page">Secteurs</span>
      </router-link>
    </li>

    <li v-if="login.loggedIn && store.state.currentUser.role !== 'COLLECTIVITY_USER' && currentVille.moduleBackoffice.find(m =>m.parametrageBOMenu === 'DEMANDES').actif" :class="'pageLink '+(active == '/demandes'?'active':'')">
      <router-link to="/demandes">
        <i class="fa fa-caret-right"></i>
        <span class="page">Demandes</span>
      </router-link>
    </li>

    <li v-if="login.loggedIn && currentVille.moduleBackoffice.find(m =>m.parametrageBOMenu === 'CONTENANTS').actif" :class="'pageLink '+(active == '/contenants'?'active':'')">
      <router-link to="/contenants">
        <i class="fa fa-caret-right"></i>
        <span class="page">Contenants</span>
      </router-link>
    </li>

    <li v-if="login.loggedIn && store.state.currentUser.role === 'ADMIN'" class="treeview menu-open" :class="'pageLink '+(active == '/administration_users' || active == '/administration_modules' || active == '/administration_anomalies' || active == '/administration_statistiques' ?'active':'')">
      <a class="no-events" href="#">
        <i class="fa fa-caret-right"></i> <span>Administration</span>
      </a>
      <ul class="treeview-menu" style="display: block;">
        <li :class="'pageLink '+(active == '/administration_users'?'active':'')">
          <router-link to="/administration_users" v-on:click="closeMenu()">
            <i class="fa fa-caret-right"></i>
            Administration <br> des utilisateurs
          </router-link>
        </li>
        <li :class="'pageLink '+(active == '/administration_modules'?'active':'')">
          <router-link to="/administration_modules">
            <i class="fa fa-caret-right"></i>
            Administration BO
          </router-link>
        </li>
         <li :class="'pageLink '+(active == '/administration_anomalies'?'active':'')">
          <router-link to="/administration_anomalies">
            <i class="fa fa-caret-right"></i>
            Administration APK
          </router-link>
        </li>
        <li :class="'pageLink '+(active == '/administration_statistiques'?'active':'')">
          <router-link to="/administration_statistiques">
            <i class="fa fa-caret-right"></i>
            KPI'S
          </router-link>
        </li>
      </ul>
    </li>
    <li :class="'pageLink '+(active == '/rgpd'?'active':'')">
      <router-link to="/rgpd">
        <i class="fa fa-caret-right"></i>
        <span class="page">Politique de <br> &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;confidentialité</span>
      </router-link>
    </li>
    <li id="logout-menu">
      <button v-on:click="logout">Se déconnecter</button>
    </li>

  </ul>
</template>
<script>
import { mapState } from 'vuex'
import store from '../store'

export default {
  name: 'SidebarName',
  computed: {
    hideSidebar() {
      console.log(this.$store.state.currentUser)
      // Access the hideSidebar flag from the route's meta object
      return this.$route.meta.hideSidebar || false;
    },
    store () {
      return store
    },
    ...mapState([
      'maitrise',
      'login',
      'implentationMaterielGeopassages',
      'maitrises',
      'demandes',
      'cantonniers',
      'secteurs',
      'materiel',
      'collectes',
      'map',
      'reporting',
      'realtime',
      'currentVille'
    ]),
    active () {
      return this.$route.path
    },
  },
  methods: {
    logout: function () {
      this.$router.push('/login');
      console.log("We continuuuuuuuuuuuuu")
      this.$store.dispatch('logout')
    },
  },
  data: function () {
    return {
      currentMaitrise: this.$store.state.maitrise,
      currenUser: this.$store.state.currentUser,
    }
  },
}
</script>
<style lang="scss">
  @import '../scss/variables';

  #logout-menu {
    text-align: center;
    margin-top: 50px;
    button {
      background-color: $suez-blue-light;
      color: $suez-white;
      border: none;
      border-radius: 5px;
      padding: 8px 25px 8px 25px;
    }
  }

  /* override default */
  .sidebar-menu>li>a {
    padding: 15px 23px;
    margin: 0;
  }
  .sidebar .sidebar-menu a {
    text-transform: uppercase;
    color: white !important;
    font: 20px 'DinCondMedium' !important;
    border: none !important;
  }

  .sidebar-menu > li > .treeview-menu {
    background: none !important;
    margin-top: -5px !important;
    margin-bottom: 10px !important;

    & > li > a {
      margin: 0 !important;
      padding: 5px 10px 5px 43px !important;

      .fa {
        font-size: 14px;
        width: 10px !important;
        vertical-align: middle;
      }
    }
  }
  .sidebar-menu li.active > a {
    color: $suez-green-yellowish !important;
    background: none !important;
    border: none !important;
  }
  .sidebar-menu li:hover > a {
    background: none !important;
    border: none !important;
  }
  .sidebar-menu a:hover, .sidebar-menu > li > .treeview-menu > li > a:hover {
    color: $suez-steel !important;
  }

  a.no-events {
    pointer-events:none;
  }

</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?784929ab